/**
 * Header Search Functionality
 */
import { getFocusableElements } from './a11y.js';
import { safeSelect, announceForScreenReader } from './utils.js';

export function initHeaderSearch() {
	const searchToggle = document.getElementById('search-button');
	const searchToggleMobile = document.getElementById('search-button-mobile');
	const searchForm = document.getElementById('header-search-form');
	const searchOverlay = document.getElementById('search-overlay');
	const searchInput = document.getElementById('search-field');
	const searchClose = searchForm?.querySelector('.search-form__close');
	
	if (!searchForm || !searchOverlay) {
		return;
	}

	// Sammle alle Such-Buttons
	const searchButtons = [searchToggle, searchToggleMobile].filter(Boolean);
	
	if (searchButtons.length === 0) {
		return;
	}

	function openSearch() {
		searchOverlay.classList.add('is-active');
		searchForm.classList.add('is-active');
		searchOverlay.setAttribute('aria-hidden', 'false');
		searchButtons.forEach(button => {
			if (button) {
				button.setAttribute('aria-expanded', 'true');
			}
		});
		document.body.classList.add('search-active');

		setTimeout(() => {
			if (searchInput) {
				searchInput.focus();
			}
		}, 100);
		
		// Tabindex für fokussierbare Elemente setzen
		const focusableElements = getFocusableElements(searchOverlay);
		focusableElements.forEach(el => {
			if (el) {
				el.setAttribute('tabindex', '0');
			}
		});
	}
	
	function closeSearch() {
		searchOverlay.classList.remove('is-active');
		searchForm.classList.remove('is-active');
		searchOverlay.setAttribute('aria-hidden', 'true');
		searchButtons.forEach(button => {
			if (button) {
				button.setAttribute('aria-expanded', 'false');
			}
		});
		document.body.classList.remove('search-active');
		
		// Tabindex zurücksetzen
		const focusableElements = getFocusableElements(searchOverlay);
		focusableElements.forEach(el => {
			if (el) {
				el.setAttribute('tabindex', '-1');
			}
		});
	}
	
	// Toggle search on click für alle Such-Buttons
	searchButtons.forEach(button => {
		if (button) {
			button.addEventListener('click', function(e) {
				e.preventDefault();
				e.stopPropagation();
				if (searchOverlay.classList.contains('is-active')) {
					closeSearch();
				} else {
					openSearch();
				}
			});
		}
	});
	
	// Close on close button click
	if (searchClose) {
		searchClose.addEventListener('click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			closeSearch();
			// Fokussiere den zuletzt verwendeten Button
			const lastUsedButton = searchButtons.find(btn => btn && document.activeElement === btn) || searchButtons[0];
			if (lastUsedButton) {
				lastUsedButton.focus();
			}
		});
	}
	
	// Close on ESC key
	document.addEventListener('keydown', function(e) {
		if (e.key === 'Escape' && searchOverlay.classList.contains('is-active')) {
			closeSearch();
			// Fokussiere den zuletzt verwendeten Button
			const lastUsedButton = searchButtons.find(btn => btn && document.activeElement === btn) || searchButtons[0];
			if (lastUsedButton) {
				lastUsedButton.focus();
			}
		}
	});
	
	// Close on click outside
	document.addEventListener('click', function(e) {
		if (searchOverlay.classList.contains('is-active') && 
			!searchOverlay.contains(e.target) && 
			!searchButtons.includes(e.target)) {
			closeSearch();
		}
	});
	
	// Handle form submission - form submits naturally, overlay will close on page load
	searchForm.addEventListener('submit', function(e) {
		const query = searchInput?.value?.trim();
		if (!query) {
			e.preventDefault();
			return false;
		}
	});
}

